import React, { useState } from "react"
import { renderHTML } from "../../agility/utils"

const FormulationTextBlock = ({ text }) => {
  // set max text length
  const textLength = 600

  // set up show state
  const [showLess, setShowLess] = useState(true)

  if (text.length < textLength) {
    return <div dangerouslySetInnerHTML={renderHTML(text)} />
  }

  return (
    <div>
      <div
        dangerouslySetInnerHTML={
          showLess
            ? renderHTML(text.slice(0, textLength) + "...")
            : renderHTML(text)
        }
      />
      <button onClick={() => setShowLess(!showLess)}>
        Read {showLess ? "More +" : "Less -"}
      </button>
    </div>
  )
}

export default FormulationTextBlock
